import axios, { AxiosError, AxiosRequestConfig } from "axios";

export const isLinkValid = async (id: string | null) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const config: AxiosRequestConfig = {
      headers: headers
    };
    if(!id) {
      return
    }
    const res = await axios.get(`${process.env.REACT_APP_CMP_API_URL}/api/v1/user-invite/${id}`, config);
    return res.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(error?.response?.data?.message);
    }
    throw new Error('Something went wrong')
  }
}

export const deactivateLink = async (id: string) => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_CMP_API_URL}/api/v1/user-invite/${id}/deactivate`);
    return res.data;
  } catch (error) {
    console.log(error);
  }
}
